'use client';

import React, { useRef, useState } from 'react';
import '../assets/styles/Contact.scss';
import emailjs from '@emailjs/browser';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';
import QRCode from 'react-qr-code';

function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

  const [nameError, setNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [messageError, setMessageError] = useState(false);

  const form = useRef<HTMLFormElement>(null);

  const sendEmail = async (e: React.FormEvent) => {
    e.preventDefault();

    const isNameEmpty = name.trim() === '';
    const isEmailEmpty = email.trim() === '';
    const isMessageEmpty = message.trim() === '';

    setNameError(isNameEmpty);
    setEmailError(isEmailEmpty);
    setMessageError(isMessageEmpty);

    if (isNameEmpty || isEmailEmpty || isMessageEmpty) return;

    setStatus('sending');

    try {
      const response = await emailjs.send(
        'service_jpw2p48',
        'template_mnm1k09',
        { name, email, message },
        '7ciqsV8EGFgFS-fgf'
      );

      setStatus('success');
      setName('');
      setEmail('');
      setMessage('');
    } catch (error) {
      console.error('❌ Failed to send email:', error);
      setStatus('error');
    }
  };

  return (
    <div id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <h1>Contact Me</h1>
          <p>Got a project waiting to be realized? Let's collaborate and make it happen!</p>
          <div className="location-note">You're reaching me in Vicenza, Italy — I'm online now!</div>

          <div className="contact-grid">
            {/* Column 1: Contact Form */}
            <Box
              component="form"
              noValidate
              autoComplete="off"
              className="contact-form"
              onSubmit={sendEmail}
            >
              <div className="form-flex">
                <TextField
                  required
                  label="Your Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  error={nameError}
                  helperText={nameError ? 'Please enter your name' : ''}
                />
                <TextField
                  required
                  label="Email / Phone"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  error={emailError}
                  helperText={emailError ? 'Please enter your email or phone number' : ''}
                />
              </div>

              <TextField
                required
                label="Message"
                multiline
                rows={10}
                className="body-form"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                error={messageError}
                helperText={messageError ? 'Please enter the message' : ''}
              />

              

              <div className="status-wrapper">
                {status === 'sending' && <p className="status sending">Sending your message…</p>}
                {status === 'success' && <p className="status success">✅ Message sent successfully!</p>}
                {status === 'error' && <p className="status error">❌ Something went wrong. Try again.</p>}
              </div>
              <div className="submit-button-wrapper">
                <Button type="submit" variant="contained" endIcon={<SendIcon />}>
                  Send
                </Button>
              </div>

              
            </Box>

            {/* Column 2: Email QR */}
            <div className="qr-card">
              <h3>Email Me Scan</h3>
              <QRCode value="mailto:ahmadhassan061@gmail.com" size={160} />
              <div>
                
                <a href="mailto:ahmadhassan061@gmail.com">  Click Here</a>
              </div>
            </div>

            {/* Column 3: WhatsApp QR */}
            <div className="qr-card">
              <h3>Chat on WhatsApp Scan </h3>
              <QRCode value="https://wa.me/393510889491" size={160} />
              <div>
                
                <a href="https://wa.me/393510889491"> Click Here</a>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
